export default __webpack_public_path__ + "static/media/small-mission.cf3091b8.png";